<template>
  <div class="droplayer icon filter-box relative" :class="isPrivateBoard ? 'task-home-b' : 'board-list-e'">
    <v-menu offset-y :close-on-content-click="false" v-model="filterShow">
      <template v-slot:activator="{ on, attrs }">
        <v-btn v-bind="attrs" v-on="on" :class="filterCount > 0 ? 'sel' : ''">필터</v-btn>
      </template>
      <div class="dropdown-list cnt board">
        <div class="dropdown-list_header">
          {{ $i18nUtil.trans("search.filter.001","{cnt}건 선택", {cnt: filterCount}) }}
          <button type="button" class="btn-refresh" v-if="filterCount > 0" @click="filterClear">새로고침</button>
        </div>
        <div class="cnt_inner clear">
          <div class="cnt-option" :class="isPrivateBoard ? 'hidden' : ''">
            <div class="tit">{{ $i18nUtil.trans("message.filter.005","공개 상태") }}</div>
            <ul>
              <li 
                v-for="(boardGradeItem, boardGradeItemIndex) in boardGradeList"
                :key="boardGradeItem.gradeCode + '_' + boardGradeItemIndex"
              >
                <input type="checkbox" name="" 
                  :id="`chkBoardGradeId`+boardGradeItemIndex" 
                  v-model="modelBoardGradeCodeList"
                  :value="boardGradeItem.gradeCode"
                /><label :for="`chkBoardGradeId`+boardGradeItemIndex">{{boardGradeItem.gradeName}}</label>
              </li>
            </ul>
          </div>
          <div class="cnt-evaluation">
            <div class="tit" v-if="tenantId !== '203'">{{ $i18nUtil.trans("message.filter.006","평가정보") }}</div>
            <div class="tit" v-if="tenantId === '203'">{{ $i18nUtil.trans('entity.projectList.status','진행단계') }}</div>
            <ul>
              <li 
                v-for="(boardStatusItem, boardStatusItemIndex) in boardStatusList"
                :key="boardStatusItem.gradeCode + '_' + boardStatusItemIndex"
                :class="'ico-txt-' +
                  (boardStatusItem.status === 'GOOD' ? 'evaluate-good' 
                  : boardStatusItem.status === 'SO' ? 'evaluate-so' 
                  : boardStatusItem.status === 'DELAY' ? 'evaluate-delay' : 'evaluate-exceeded')"
              >
                <input type="checkbox" name="" 
                  :id="`chkBoardStatusId`+boardStatusItemIndex" 
                  v-model="modelBoardStatusCodeList"
                  :value="boardStatusItem.status"
                /><label :for="`chkBoardStatusId`+boardStatusItemIndex">{{boardStatusItem.statusName}}</label>
              </li>
            </ul>
          </div>
        </div>
        <div class="dropdown-list_foot">
          <button type="button" class="btn-primary-small" @click="recoverFilter">{{ $i18nUtil.trans("button.filter.cancel","취소") }}</button>
          <button type="button" class="btn-primary-small black" @click="applyFilter">{{ $i18nUtil.trans("button.filter.apply","적용") }}</button>
        </div>
      </div>
    </v-menu>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";
export default {
  props: ["filterReset","initFilter", "ignoreChineseWallUse", "isPrivateBoard"],
  data() {
    return {
      tenantId: localStorage.getItem("tenantId"),
      filterCount: 0,
      boardGradeList: [
          {gradeCode: 'RESTRICT', gradeName: this.$i18nUtil.trans("entity.paper.docGrade.RESTRICT","멤버만 공개")}
        , {gradeCode: 'SECRET', gradeName: this.$i18nUtil.trans("entity.paper.docGrade.SECRET","비공개")}
      ],
      prevModelBoardGradeCodeList: [],
      modelBoardGradeCodeList: [],
      boardStatusList: [
          {status: 'GOOD', statusName: this.$i18nUtil.trans("entity.paper.paperStatus.GOOD","정상")}
        , {status: 'SO', statusName: this.$i18nUtil.trans("entity.paper.paperStatus.SO","이슈 발생")}
        , {status: 'DELAY', statusName: this.$i18nUtil.trans("entity.paper.paperStatus.DELAY","보고 필요")}
        , {status: 'EXCEEDED', statusName: this.$i18nUtil.trans("entity.paper.paperStatus.EXCEEDED","종료")}
      ],
      modelBoardStatusCodeList: [],
      prevModelBoardStatusCodeList: [],
      filterShow: false,
      filterApply: false,
    };
  },
  watch: {
    filterShow: {
      handler() {
        let obj = this;
        setTimeout(()=> {
          if(!obj.filterShow && !obj.filterApply) {
            obj.modelBoardGradeCodeList = obj.prevModelBoardGradeCodeList;
            obj.modelBoardStatusCodeList = obj.prevModelBoardStatusCodeList;
          }
  
          if(obj.filterApply) {
            obj.filterApply = false;
          }
        }, 50);
      }
    },
    modelBoardGradeCodeList: {
      handler() {
        this.filterCount = this.modelBoardStatusCodeList.length + this.modelBoardGradeCodeList.length;    
      }
    },
    modelBoardStatusCodeList: {
      handler() {
        this.filterCount = this.modelBoardStatusCodeList.length + this.modelBoardGradeCodeList.length;
      }
    },
    filterReset: {
      handler() {
        let obj = this;
        if(this.$props.filterReset) {
          obj.prevModelBoardGradeCodeList = [];
          obj.prevModelBoardStatusCodeList = [];
          obj.filterClear();
        }

      }
    },
    initFilter:{
      handler(){
        let obj = this;
        if(obj.initFilter.gradeCodeList.length != 0){ /*  && initFilter.gradeCodeList.length != obj.boardGradeList.length */
          this.modelBoardGradeCodeList = this.initFilter.gradeCodeList;
          this.prevModelBoardGradeCodeList = this.initFilter.gradeCodeList;
        }
        if(obj.initFilter.statusList.length != 0){ /* && obj.initFilter.statusList.length != obj.boardStatusList.length */
          this.modelBoardStatusCodeList = this.initFilter.statusList;
          this.prevModelBoardStatusCodeList = this.initFilter.statusList;
        }
        this.filterShow = false;
        this.filterApply = true;
      }
    }
  },
  mounted() {
    this.checkChineseWallUse();
  },
  methods: {
    ...mapActions("restAction", ["COWORK_REST_SIMPLE_ACTION"]),
    // chinese.wall.use 사용여부 체크
    checkChineseWallUse() {
      let obj = this;
      let reqData = {
        url : "/api/org/getCodeValueList",
        method : "post",
        params : {
          cdCategory: 'tenant.env',
          cdKey: 'chinese.wall.use'
        }
      };
      obj
      .COWORK_REST_SIMPLE_ACTION(reqData)
      .then(function(res) {
        let codeList = res.result;
        let isChineseWallUse = codeList[0].cdValue;
        if (obj.$props.ignoreChineseWallUse || isChineseWallUse == "false") {
          obj.boardGradeList.splice(0, 0, {gradeCode: 'NORMAL', gradeName: obj.$i18nUtil.trans("entity.paper.docGrade.NORMAL","전체공개")});
        }
      })
      .catch(function(err) {
        console.log(err);
      });
    },
    // 필터 새로고침
    filterClear() {
      let obj = this;
      obj.modelBoardGradeCodeList = [];
      obj.modelBoardStatusCodeList = [];
    },
    // 필터 취소
    recoverFilter() {
      let obj = this;
      // 필터 되돌림
      obj.modelBoardGradeCodeList = obj.prevModelBoardGradeCodeList;
      obj.modelBoardStatusCodeList = obj.prevModelBoardStatusCodeList;
      obj.filterShow = false;
      obj.filterApply = false;
    },
    // 필터 적용
    applyFilter() {
      let obj = this;
      // 필터 변경
      obj.prevModelBoardGradeCodeList = obj.modelBoardGradeCodeList;
      obj.prevModelBoardStatusCodeList = obj.modelBoardStatusCodeList;
      obj.filterShow = false;
      obj.filterApply = true;
      let rtnBoardGradeCodeList = obj.modelBoardGradeCodeList.length == 0 ? [] : obj.modelBoardGradeCodeList;
      let rtnBoardStatusCodeList = obj.modelBoardStatusCodeList.length == 0 ? [] : obj.modelBoardStatusCodeList;
      
      let gradeCheckYn  = true;
      let statusCheckYn  = true;

      if(obj.modelBoardGradeCodeList.length == 0) {
        gradeCheckYn  = false;
        obj.boardGradeList.forEach((elem)=> {
          rtnBoardGradeCodeList.push(elem.gradeCode);
        });
      }
      if(obj.modelBoardStatusCodeList.length == 0) {
        statusCheckYn  = false;
        obj.boardStatusList.forEach((elem)=> {
          rtnBoardStatusCodeList.push(elem.status);
        });
      }
      obj.$emit('updateCommonFilterE'
        , {
            filterGradeList: rtnBoardGradeCodeList, 
            filterStatusList: rtnBoardStatusCodeList,
            gradeCheckYn: gradeCheckYn,
            statusCheckYn: statusCheckYn
          }
      );
    },
  }
}
</script>


// WEBPACK FOOTER //
// src/components/cowork/common/filter/CommonFilterE.vue